import React, { useState } from 'react';
import styles from './PasswordInput.module.css';
import { EyeOpenIcon, EyeClosedIcon } from './icons';

interface PasswordInputProps {
  id: string;
  name: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  className?: string;
  autoComplete?: 'current-password' | 'new-password' | 'off';
  required?: boolean;
  'data-testid'?: string;
  error?: boolean;
}

/**
 * パスワード表示/非表示切り替え機能付きパスワード入力コンポーネント
 */
const PasswordInput: React.FC<PasswordInputProps> = ({
  id,
  name,
  value,
  onChange,
  placeholder = "••••••••",
  className = "",
  autoComplete = "current-password",
  required = false,
  'data-testid': dataTestId,
  error = false
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className={styles['password-input-container']}>
      <input
        id={id}
        name={name}
        type={showPassword ? "text" : "password"}
        className={`${styles['password-input']} ${className} ${error ? styles['password-input--error'] : ''}`}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        autoComplete={autoComplete}
        required={required}
        data-testid={dataTestId}
      />
      <button
        type="button"
        className={styles['password-toggle-button']}
        onClick={togglePasswordVisibility}
        aria-label={showPassword ? "パスワードを隠す" : "パスワードを表示"}
        data-testid={dataTestId ? `${dataTestId}-toggle` : undefined}
      >
        {showPassword ? (
          <EyeClosedIcon className={styles['password-toggle-icon']} />
        ) : (
          <EyeOpenIcon className={styles['password-toggle-icon']} />
        )}
      </button>
    </div>
  );
};

export default PasswordInput;
